require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[55],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{content:\"\";position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;color:#1f57a4}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{color:#fff}}.ba-common-simpletable-fixed-headers{width:100%;table-layout:fixed;border-collapse:collapse;background-color:#fff;display:block}.ba-common-simpletable-fixed-headers th,.ba-common-simpletable-fixed-headers td{display:block;text-align:left;vertical-align:middle}.ba-common-simpletable-caption{display:block}.ba-common-simpletable-thead{font-size:.875rem;font-weight:600;line-height:1.125rem;letter-spacing:.16px;background-color:#e0e0e0;display:block;width:100%}.ba-common-simpletable-thead-row{display:flex;flex-direction:row;width:100%}.ba-common-simpletable-thead-row th:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-thead-row .ba-common-checkbox{margin:5px 0}.ba-common-simpletable-tbody{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;background-color:#fff;overflow:auto;width:100%;display:block}.ba-common-simpletable-tbody-row{display:flex;flex-direction:row;width:100%;position:relative}.ba-common-simpletable-tbody-row:hover{background:#e5e5e5}.ba-common-simpletable-tbody-row:hover td{color:#161616;background:#e5e5e5;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5}.ba-common-simpletable-tbody-row.is-selected,.ba-common-simpletable-tbody-row.is-selected:hover{background-color:rgba(31,87,164,.1)}.ba-common-simpletable-tbody-row.is-selected td:first-child div.ba-common-container,.ba-common-simpletable-tbody-row.is-selected:hover td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px #1f57a4}.ba-common-simpletable-tbody-row.is-dragging{opacity:.5}.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{bottom:-1px}.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after{top:-1px}.ba-common-simpletable-tbody-row td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-tbody-row td{display:block;color:#525252;background:#fff;border-top:1px solid #fff;border-bottom:1px solid #e0e0e0}.ba-common-simpletable-tbody-row .ba-common-checkbox{margin:4px 0}.old_ie_wrapper{width:100%;overflow-x:hidden;overflow-y:auto}.old_ie_wrapper tbody{height:auto}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row:hover{background-color:#1f57a4}}", ""]);

// exports
exports.locals = {
	"stClassName": "\"ba-common-simpletable\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(493);


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SimpleTable = _interopRequireDefault(__webpack_require__(494));

exports.default = _SimpleTable.default;
exports.SimpleTable = _SimpleTable.default;

var _helper = _interopRequireDefault(__webpack_require__(85));

exports.SimpleTableHelpers = _helper.default;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _THead = _interopRequireDefault(__webpack_require__(495));

var _TBody = _interopRequireDefault(__webpack_require__(496));

var _TBodyDnD = _interopRequireDefault(__webpack_require__(497));

var _simpletable = _interopRequireDefault(__webpack_require__(50));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const stClassName = _simpletable.default.stClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;

class SimpleTable extends _react.Component {
  onSelect(row) {
    if (this.tbodydnd) {
      this.tbodydnd.onSelect(row);
    } else if (this.tbody) {
      this.tbody.onSelect(row);
    }
  }

  render() {
    const {
      rowLength,
      colToAddScopeRow,
      caption,
      className,
      colLength,
      cellRenderer,
      headerRenderer,
      onRowMove,
      onRowOut,
      widthDivision,
      height,
      draggable,
      onRowHover,
      onRowClick,
      ...others
    } = this.props;
    const tHeaderProps = {
      colLength,
      headerRenderer,
      widthDivision
    };
    const tBodyProps = {
      rowLength,
      colToAddScopeRow,
      colLength,
      cellRenderer,
      onRowMove,
      onRowOut,
      widthDivision,
      height,
      draggable,
      onRowHover,
      onRowClick
    };
    return /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({}, sanitize(others, SimpleTable), {
      className: `${stClassName}-fixed-headers ${className}`
    }), caption && /*#__PURE__*/_react.default.createElement("caption", {
      className: `${stClassName}-caption`
    }, caption), /*#__PURE__*/_react.default.createElement(_THead.default, tHeaderProps), !this.props.draggable && /*#__PURE__*/_react.default.createElement(_TBody.default, (0, _extends2.default)({
      ref: r => {
        this.tbody = r;
      }
    }, tBodyProps)), this.props.draggable && /*#__PURE__*/_react.default.createElement(_TBodyDnD.default, (0, _extends2.default)({
      ref: r => {
        this.tbodydnd = r;
      }
    }, tBodyProps)));
  }

}

exports.default = SimpleTable;
(0, _defineProperty2.default)(SimpleTable, "propTypes", {
  /** Is the number of rows you plan to load in table */
  rowLength: _propTypes.default.number,

  /** Custom class name(s) */
  className: _propTypes.default.string,

  /** Set to column index for the first idnetifiable td that has text in a row. (accessibility requirement) */
  colToAddScopeRow: _propTypes.default.number,

  /** A brief descriptive text, that indicates the content of that table (accessibility requirement) */
  caption: _propTypes.default.string,

  /** Is the number of columns you plan to load in table */
  colLength: _propTypes.default.number,

  /** Pass a callback function with row and column index as arguments */
  cellRenderer: _propTypes.default.func,

  /** Pass a callback function with column index as arguments */
  headerRenderer: _propTypes.default.func,

  /** Pass a callback function with arguments as source and target row index respectively */
  onRowMove: _propTypes.default.func,

  /** Pass a callback function with arguments as row index. Triggers on row mouse out */
  onRowOut: _propTypes.default.func,

  /** Set width division as key-value pair */
  widthDivision: _propTypes.default.object,

  /** Set height of table */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Boolean value to make rows draggable */
  draggable: _propTypes.default.bool,

  /** Pass a callback function with arguments as rowIndex. Triggers on row mouse over. */
  onRowHover: _propTypes.default.func,

  /** Pass a callback function with arguments as rowIndex. Triggers on row click. */
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _Row = _interopRequireDefault(__webpack_require__(84));

var _simpletable = _interopRequireDefault(__webpack_require__(50));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const stClassName = _simpletable.default.stClassName.replace(/"/g, '');

class THead extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("thead", {
      className: `${stClassName}-thead`
    }, /*#__PURE__*/_react.default.createElement(_Row.default, {
      className: `${stClassName}-thead-row`,
      widthDivision: this.props.widthDivision,
      colLength: this.props.colLength,
      headerRenderer: this.props.headerRenderer,
      headerRow: true
    }));
  }

}

exports.default = THead;
(0, _defineProperty2.default)(THead, "propTypes", {
  headerRenderer: _propTypes.default.func,
  colLength: _propTypes.default.number,
  widthDivision: _propTypes.default.object
});

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _helper = _interopRequireDefault(__webpack_require__(85));

var _Row = _interopRequireDefault(__webpack_require__(84));

var _simpletable = _interopRequireDefault(__webpack_require__(50));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const stClassName = _simpletable.default.stClassName.replace(/"/g, '');

class TBody extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_assignRef", (ref, index) => {
      this[`row${index}`] = ref;
    });
  }

  componentDidMount() {
    _helper.default.resizeThead(this.tbody);
  }

  onSelect(row) {
    this[`row${row}`].onSelect(row);
  }

  render() {
    let height = {};

    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }

    const rows = [];

    for (let index = 0; index < this.props.rowLength; index++) {
      rows.push( /*#__PURE__*/_react.default.createElement(_Row.default, {
        className: `${stClassName}-tbody-row`,
        onRef: ref => {
          this._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: this.props.colToAddScopeRow,
        colLength: this.props.colLength,
        cellRenderer: this.props.cellRenderer,
        widthDivision: this.props.widthDivision,
        onRowHover: this.props.onRowHover,
        onRowOut: this.props.onRowOut,
        onRowClick: this.props.onRowClick
      }));
    }

    return /*#__PURE__*/_react.default.createElement("tbody", {
      ref: r => {
        this.tbody = r;
      },
      className: `${stClassName}-tbody`,
      style: height
    }, rows);
  }

}

exports.default = TBody;
(0, _defineProperty2.default)(TBody, "propTypes", {
  rowLength: _propTypes.default.number,
  colToAddScopeRow: _propTypes.default.number,
  colLength: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  onRowOut: _propTypes.default.func,
  widthDivision: _propTypes.default.object,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onRowHover: _propTypes.default.func,
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _helper = _interopRequireDefault(__webpack_require__(85));

var _RowDnD = _interopRequireDefault(__webpack_require__(498));

var _simpletable = _interopRequireDefault(__webpack_require__(50));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const stClassName = _simpletable.default.stClassName.replace(/"/g, '');

class TBodyDnD extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "_assignRef", (ref, index) => {
      this[`rowdnd${index}`] = ref;
    });
  }

  componentDidMount() {
    _helper.default.resizeThead(this.tbody);
  }

  onSelect(row) {
    this[`rowdnd${row}`].onSelect(row);
  }

  render() {
    let height = {};

    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }

    const rows = [];

    for (let index = 0; index < this.props.rowLength; index++) {
      rows.push( /*#__PURE__*/_react.default.createElement(_RowDnD.default, {
        onRef: ref => {
          this._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: this.props.colToAddScopeRow,
        colLength: this.props.colLength,
        rowLength: this.props.rowLength,
        cellRenderer: this.props.cellRenderer,
        widthDivision: this.props.widthDivision,
        onRowHover: this.props.onRowHover,
        onRowMove: this.props.onRowMove,
        onRowOut: this.props.onRowOut,
        hoveredAbove: this.state.hoveredAbove
      }));
    }

    return /*#__PURE__*/_react.default.createElement("tbody", {
      ref: r => {
        this.tbody = r;
      },
      className: `${stClassName}-tbody`,
      style: height
    }, rows);
  }

}

(0, _defineProperty2.default)(TBodyDnD, "propTypes", {
  rowLength: _propTypes.default.number,
  colToAddScopeRow: _propTypes.default.number,
  colLength: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  onRowMove: _propTypes.default.func,
  widthDivision: _propTypes.default.object,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onRowHover: _propTypes.default.func,
  onRowOut: _propTypes.default.func
});
var _default = TBodyDnD;
exports.default = _default;

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _reactDom = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _reactDnd = __webpack_require__(23);

var _Row = _interopRequireDefault(__webpack_require__(84));

var _simpletable = _interopRequireDefault(__webpack_require__(50));

var _dec, _dec2, _class, _class2, _temp;

const stClassName = _simpletable.default.stClassName.replace(/"/g, '');

const style = {
  width: '100%',
  cursor: 'move'
};
/** Calculate position percentage of hovering on current row */

function getHoveredYPercent(props, monitor, component) {
  const hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
  const clientOffset = monitor.getClientOffset();
  const hoverClientY = clientOffset.y - hoverBoundingRect.top;
  const hoveredYPercent = hoverClientY / (hoverBoundingRect.bottom - hoverBoundingRect.top) * 100;
  return hoveredYPercent;
}
/** Methods trigger when Element is dragged */


const draggableSource = {
  beginDrag(props) {
    return {
      rowKey: props.rowKey
    };
  }

};

const connectDS = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});
/** Methods trigger when Element is dropped */


const connectDT = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
});

const draggableComponentTarget = {
  drop(props, monitor, component) {
    const hoveredYPercent = getHoveredYPercent(props, monitor, component);
    const sourceId = monitor.getItem().rowKey;
    const targetId = props.rowKey;
    if (sourceId === targetId) return; // move down

    if (sourceId < targetId) {
      if (hoveredYPercent > 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId - 1);
      } // move up

    } else if (sourceId > targetId) {
      if (hoveredYPercent < 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId + 1);
      }
    }
  },

  hover(props, monitor, component) {
    const hoveredAbove = getHoveredYPercent(props, monitor, component) <= 50;
    const className = hoveredAbove ? (0, _utils.classnames)('hoveredAbove') : (0, _utils.classnames)('hoveredBelow');
    (0, _reactDom.findDOMNode)(component).classList.add(className);
  }

};
/** Custom Draggable Component */

let RowDnD = (_dec = (0, _reactDnd.DropTarget)('draggableList', draggableComponentTarget, connectDT), _dec2 = (0, _reactDnd.DragSource)('draggableList', draggableSource, connectDS), _dec(_class = _dec2(_class = (_temp = _class2 = class RowDnD extends _react.Component {
  onSelect() {
    this.setState(state => ({
      selected: !state.selected
    }));
  }

  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      canDrop,
      isOver,
      rowLength,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      ...other
    } = this.props;
    /** Essential to make Componet both Draggable and Droppable */

    return /*#__PURE__*/_react.default.createElement(_Row.default, (0, _extends2.default)({
      className: (0, _utils.classnames)(`${stClassName}-tbody-row`, {
        dragging: isDragging,
        active: canDrop && isOver
      }),
      style: { ...style
      }
    }, other, {
      ref: instance => {
        const node = (0, _reactDom.findDOMNode)(instance);
        connectDragSource(node);
        connectDropTarget(node);
      }
    }));
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired,
  connectDragSource: _propTypes.default.func.isRequired,
  isDragging: _propTypes.default.bool,
  isOver: _propTypes.default.bool,
  canDrop: _propTypes.default.bool,

  /** Props you like to import */
  index: _propTypes.default.number,
  onRowMove: _propTypes.default.func,
  rowLength: _propTypes.default.number,
  name: _propTypes.default.string
}), _temp)) || _class) || _class);
exports.default = RowDnD;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_simpletable_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
class Row extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onHover", () => {
      this.props.onRowHover && this.props.onRowHover(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_onLeave", () => {
      this.props.onRowOut && this.props.onRowOut(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_onClick", () => {
      this.props.onRowClick && this.props.onRowClick(this.props.rowKey);
    });
    (0, _defineProperty2.default)(this, "_renderRows", () => {
      let count = 0;
      let totalWidth = 0; // accessibility requirement to add scope as row

      const {
        colToAddScopeRow
      } = this.props;

      if (this.props.widthDivision) {
        Object.keys(this.props.widthDivision).forEach(index => {
          totalWidth += parseInt(this.props.widthDivision[index].split('px')[0], 0);
          count += 1;
        });
      }

      totalWidth += 'px';

      if (!this.props.headerRow) {
        return Array(this.props.colLength).fill().map((item, colIndex) => {
          let width = '';

          if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
            width = this.props.widthDivision[colIndex];
          } else {
            width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
          }

          let tdScope = {};

          if (colIndex === colToAddScopeRow) {
            tdScope = {
              scope: 'row'
            };
          }

          return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({
            style: {
              minWidth: width,
              maxWidth: width,
              width
            },
            key: colIndex
          }, tdScope), this.props.cellRenderer && this.props.cellRenderer(this.props.rowKey, colIndex));
        });
      }

      return Array(this.props.colLength).fill().map((item, colIndex) => {
        let width = '';

        if (this.props.widthDivision && this.props.widthDivision[colIndex]) {
          width = this.props.widthDivision[colIndex];
        } else {
          width = `calc((100% - ${totalWidth}) / ${this.props.colLength - count})`;
        }

        return /*#__PURE__*/_react.default.createElement("th", {
          style: {
            minWidth: width,
            maxWidth: width,
            width
          },
          key: colIndex,
          scope: "col"
        }, this.props.headerRenderer && this.props.headerRenderer(colIndex));
      });
    });
    this.state = {
      selected: false
    };
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef && this.props.onRef(undefined);
  }

  onSelect() {
    this.setState(state => ({
      selected: !state.selected
    }));
  }

  render() {
    const {
      className,
      style
    } = this.props;
    const {
      selected
    } = this.state;
    const classNames = (0, _utils.classnames)({
      selected
    });
    return /*#__PURE__*/_react.default.createElement("tr", {
      // eslint-disable-line jsx-a11y/mouse-events-have-key-events
      style: style,
      className: `${classNames} ${className}`,
      onClick: () => {
        this._onClick();
      },
      onMouseOver: () => {
        this._onHover();
      },
      onMouseOut: () => {
        this._onLeave();
      }
    }, this._renderRows());
  }

}

exports.default = Row;
(0, _defineProperty2.default)(Row, "propTypes", {
  colToAddScopeRow: _propTypes.default.number,
  cellRenderer: _propTypes.default.func,
  className: _propTypes.default.string,
  colLength: _propTypes.default.number,
  headerRenderer: _propTypes.default.func,
  headerRow: _propTypes.default.bool,
  onRowHover: _propTypes.default.func,
  onRowOut: _propTypes.default.func,
  onRef: _propTypes.default.func,
  rowKey: _propTypes.default.number,
  style: _propTypes.default.object,
  widthDivision: _propTypes.default.object,
  onRowClick: _propTypes.default.func
});

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

function reOrderRow(arr, from, to) {
  const objData = [...arr];
  objData.splice(to, 0, objData.splice(from, 1)[0]);
  return objData;
}
/**
 * Special case for handling scenario in Windows OS browsers,
 * when scrollbar appears in TBody,
 * learn more from rtc defect 235531
 */


function resizeThead(tbody) {
  const thead = tbody.parentElement.children[0].children[0];

  if (navigator.appVersion.indexOf('Win') !== -1) {
    if (tbody.scrollHeight > tbody.clientHeight) {
      const SCROLLBAR_WIDTH = '17px';
      thead.style.width = `calc(100% - ${SCROLLBAR_WIDTH})`;
    }
  }
}

var _default = {
  reOrderRow,
  resizeThead
};
exports.default = _default;

/***/ })

},[[492,0]]]);
});